import { Dispatch, SetStateAction, useCallback, useState } from 'react';

/**
 * useBoolean
 * helper for managing a boolean state
 *
 * returns [ booleanValue, setToTrueMethod, setToFalseMethod, toggleMethod, resetMethod, setValue ]
 */

type UseBooleanReturnType = [
  boolean,
  VoidFunction,
  VoidFunction,
  VoidFunction,
  VoidFunction,
  Dispatch<SetStateAction<boolean>>,
];

export function useBoolean(initialState = false): UseBooleanReturnType {
  const [value, setValue] = useState<boolean>(initialState);

  const setTrue = useCallback(() => setValue(true), []);
  const setFalse = useCallback(() => setValue(false), []);
  const toggle = useCallback(() => setValue(prev => !prev), []);
  const reset = useCallback(() => setValue(initialState), [initialState]);

  return [value, setTrue, setFalse, toggle, reset, setValue];
}
